import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import logo from '../../resources/image/logo.svg';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

export const auth = {
    isAuthenticated: false,
    authenticate() {
        this.isAuthenticated = true;
    },
    signout() {
        this.isAuthenticated = false;
    }
};

const ProgressIndicatorTheme = theme => ({
    buttonProgress: {
        color: '#353232',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
});

export const ProgressIndicator = withStyles(ProgressIndicatorTheme)((props) => {
    return props.condition && <CircularProgress size={24} className={props.classes.buttonProgress}/>;
});

ProgressIndicator.defaultProps = {
    condition: false
};

export const Logo = props => {
    return <div className={props.classes.logo}>
        <img src={logo} alt=''/>
    </div>;
};

Logo.propTypes = {
    classes: PropTypes.object.isRequired
};

export const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

export const SwitchingHeader = props => {
    return <Typography component="h3" variant="h4" align="center" color="textPrimary" gutterBottom>
        {props.text}
    </Typography>
};

export default {
    ProgressIndicator, Logo
}